import clsx from "clsx";
import * as React from "react";
import { BadgeProps } from "../@types/badge";

export default function Badge(props: BadgeProps) {
  const {
    endIcon,
    children,
    leftIcon,
    rightIcon,
    startIcon,
    className,
    pill = true,
    // variant = "solid",
    color = "primary",
  } = props;

  return (
    <span className={clsx("badge", `bg-${color}`, pill && "rounded-pill", className)}>
      {startIcon}
      {leftIcon}
      {children}
      {rightIcon}
      {endIcon}
    </span>
  );
}
